import Page from 'components/pages/stylist-events'

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params }) {
  const [category, cityId, districtId] = params.params
  if (!store.stylistEventFilterCategories.includes(category)) {
    const city = category && await store.findCity(category, 'key')
    if (!city) return { notFound: true }
    return {
      redirect: {
        destination: h.path.stylistEvents({ city: city.key, district: cityId }),
        permanent: false
      }
    }
  }

  const city = cityId && await store.findCity(cityId, 'key')
  if (cityId && !city) return { notFound: true }
  const district = districtId && await store.findDistrict(city.name, districtId, 'key')
  if (districtId && !district) return { notFound: true }

  const fetchBreadcrumbs = () => {
    if (!city) return null
    const list = [
      {
        name: i18n.t('common:breadcrumb.stylistEvents'),
        href: h.path.stylistEvents()
      },
      {
        name: city.name,
        href: h.path.stylistEvents({ city: cityId })
      }
    ]

    if (district) list.push({ name: district.name })
    return list
  }

  const breadcrumbs = fetchBreadcrumbs()
  const fetchRegion = () => {
    if (!city) return ''
    if (!district) return city.name
    return city.name + district.name
  }
  const region = fetchRegion()

  return { props: { category, breadcrumbs, region }, revalidate: 60 * 60 }
}

export default function StylistEvents({ category, breadcrumbs, region }) {
  const t = useI18n()
  const router = useRouter()
  const description = t('seo:stylistEvents.defaultDesc', { region })
  const year = dayjs().year()
  const serviceCategory = t(`common:service.category.${category}`)
  const title = t.seo.title('stylistEvents', { year, region, category: serviceCategory })
  const url = router.url
  return (
    <>
      <C.Head>
        { h.seo({ title, description }) }
        { h.og({
          image: {
            url: cdn('images/stylemap_v2.jpg'),
            width: 1200,
            height: 628
          }
        }) }
        { h.ldjson({
          '@context': 'http://schema.org/',
          '@type': 'BreadcrumbList',
          'itemListElement': [{
            'position': 1,
            '@type': 'ListItem',
            'item': {
              '@id': h.path.full.root(),
              'name': 'StyleMap'
            }
          }, {
            'position': 2,
            '@type': 'ListItem',
            'item': {
              '@id': h.path.full.stylistEvents(),
              'name': t('seo:stylistEvents.title', { year, region: '', category: serviceCategory })
            }
          }, {
            'position': 3,
            '@type': 'ListItem',
            'item': {
              '@id': url,
              'name': t('seo:stylistEvents.title', { year, region, category: serviceCategory })
            }
          }]
        }) }
        { h.ldjson({
          '@context': 'http://schema.org/',
          '@type': 'FAQPage',
          '@id': url,
          'headline': title,
          'mainEntity': [
            {
              '@type': 'Question',
              'name': t('seo:faq.question1'),
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': t('seo:faq.answer1', { url })
              }
            },
            {
              '@type': 'Question',
              'name': t('seo:faq.question2'),
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': t('seo:faq.answer2', { url })
              }
            }
          ]
        }) }
      </C.Head>
      <Page type='stylist' breadcrumbs={ breadcrumbs } category={ category } serviceCategory={ serviceCategory }/>
    </>
  )
}
